<div class="border border-gray-200 rounded px-4 py-3">

  <div *ngIf="loading" class="py-2 text-sm text-gray-400 italic">
    Loading analysis data...
  </div>

  <div *ngIf="!loading && groups.length === 0" class="py-2 text-sm text-gray-400 italic">
    No analysis data available for this pin.
  </div>

  <div *ngIf="!loading && groups.length > 0" class="space-y-3">
    <div *ngFor="let group of groups; trackBy: trackByType" class="bg-gray-50 rounded p-3">
      <p class="text-xs font-semibold text-gray-600 uppercase tracking-wide">
        {{ group.type }}
      </p>
      <p *ngIf="group.period" class="text-xs text-[var(--primary-dark-variant)] mb-1">
        {{ group.period }}
      </p>
      <div class="grid grid-cols-2 gap-x-4 gap-y-1">
        <ng-container *ngFor="let item of group.items; trackBy: trackByChartId">
          <span class="text-xs text-gray-500">{{ item.label }}</span>
          <span class="text-xs text-gray-700 text-right">{{ item.value }}</span>
        </ng-container>
      </div>
    </div>
  </div>

</div>
